// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { WayfindingMap } from "generated/mos/org/getty/audio";
import { Amenity, VisitorInfoPage, VisitorInfoSiteContent } from "generated/mos/org/getty/visitorinfo";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, stripTypePropertyDeep } from "generated/webrpc";

export namespace GetAmenityRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.Amenity');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a GetAmenityRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_access.GetAmenityRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetAmenityRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace GetAmenityResponse {
  export const refName = "mos.org.getty.visitor_info_access.GetAmenityResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenity: Amenity.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    amenity: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["amenity"] = Amenity.codec.encode(v.amenity);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetAmenityResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenity"] = ctx.decode(Amenity.codec, v["amenity"], "amenity");
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorInfoPageRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoPage');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a GetVisitorInfoPageRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_access.GetVisitorInfoPageRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetVisitorInfoPageRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorInfoPageResponse {
  export const refName = "mos.org.getty.visitor_info_access.GetVisitorInfoPageResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPage: VisitorInfoPage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPage: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoPage"] = VisitorInfoPage.codec.encode(v.visitorInfoPage);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetVisitorInfoPageResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPage"] = ctx.decode(VisitorInfoPage.codec, v["visitorInfoPage"], "visitorInfoPage");
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorInfoSiteContentRequest {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoSiteContent');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a GetVisitorInfoSiteContentRequest`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info_access.GetVisitorInfoSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly siteContentRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    siteContentRef: undefined,
    siteRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetVisitorInfoSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteContentRef"] = v["siteContentRef"];
      out["siteRef"] = v["siteRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorInfoSiteContentResponse {
  export const refName = "mos.org.getty.visitor_info_access.GetVisitorInfoSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContent: VisitorInfoSiteContent.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContent: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.GetVisitorInfoSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContent"] = ctx.decode(VisitorInfoSiteContent.codec, v["visitorInfoSiteContent"], "visitorInfoSiteContent");
      return out as any as Entity;
    }
  }();
}

export namespace ListAmenitiesRequest {
  export const refName = "mos.org.getty.visitor_info_access.ListAmenitiesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListAmenitiesRequest.ByRef.Entity | ListAmenitiesRequest.ByAmenityCategoryRef.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByAmenityCategoryRef") {
            obj["byAmenityCategoryRef"] = ListAmenitiesRequest.ByAmenityCategoryRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByRef") {
            obj["byRef"] = ListAmenitiesRequest.ByRef.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.visitor_info_access.ListAmenitiesRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListAmenitiesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byAmenityCategoryRef"] !== undefined) {
          out["filter"] = ctx.decode(ListAmenitiesRequest.ByAmenityCategoryRef.codec, v["byAmenityCategoryRef"], "byAmenityCategoryRef");
        }
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListAmenitiesRequest.ByRef.codec, v["byRef"], "byRef");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly amenityRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      amenityRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["amenityRefs"] = v["amenityRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace ByAmenityCategoryRef {
    export const refName = "mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByAmenityCategoryRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly amenityCategoryRef: { readonly typename: 'mos.org.getty.visitor_info.AmenityCategory', readonly id: string } | undefined,
    }
    export const defaults: Entity = {
      type: refName,
      amenityCategoryRef: undefined,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListAmenitiesRequest.ByAmenityCategoryRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["amenityCategoryRef"] = v["amenityCategoryRef"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListAmenitiesResponse {
  export const refName = "mos.org.getty.visitor_info_access.ListAmenitiesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly amenities: ReadonlyArray<Amenity.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    amenities: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["amenities"] = [];
      for (const item of v.amenities) {
        obj["amenities"].push(Amenity.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListAmenitiesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["amenities"] = decodeMessageRepeated(ctx, Amenity.codec, v["amenities"], "amenities");
      return out as any as Entity;
    }
  }();
}

export namespace ListVisitorInfoPagesRequest {
  export const refName = "mos.org.getty.visitor_info_access.ListVisitorInfoPagesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListVisitorInfoPagesRequest.VisitorInfoPagesFilter.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListVisitorInfoPagesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["filter"] = ctx.decode(ListVisitorInfoPagesRequest.VisitorInfoPagesFilter.codec, v["filter"], "filter");
      return out as any as Entity;
    }
  }();
  export namespace VisitorInfoPagesFilter {
    export const refName = "mos.org.getty.visitor_info_access.ListVisitorInfoPagesRequest.VisitorInfoPagesFilter" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly byRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string }>,
      readonly bySites: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
      readonly siteContentRef: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      byRefs: [],
      bySites: [],
      siteContentRef: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListVisitorInfoPagesRequest.VisitorInfoPagesFilter");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["byRefs"] = v["byRefs"];
        out["bySites"] = v["bySites"];
        out["siteContentRef"] = v["siteContentRef"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListVisitorInfoPagesResponse {
  export const refName = "mos.org.getty.visitor_info_access.ListVisitorInfoPagesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoPage: ReadonlyArray<VisitorInfoPage.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoPage: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorInfoPage"] = [];
      for (const item of v.visitorInfoPage) {
        obj["visitorInfoPage"].push(VisitorInfoPage.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListVisitorInfoPagesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoPage"] = decodeMessageRepeated(ctx, VisitorInfoPage.codec, v["visitorInfoPage"], "visitorInfoPage");
      return out as any as Entity;
    }
  }();
}

export namespace ListVisitorInfoSiteContentsRequest {
  export const refName = "mos.org.getty.visitor_info_access.ListVisitorInfoSiteContentsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
  }
  export const defaults: Entity = {
    type: refName,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListVisitorInfoSiteContentsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      return out as any as Entity;
    }
  }();
}

export namespace ListVisitorInfoSiteContentsResponse {
  export const refName = "mos.org.getty.visitor_info_access.ListVisitorInfoSiteContentsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorInfoSiteContent: ReadonlyArray<VisitorInfoSiteContent.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    visitorInfoSiteContent: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListVisitorInfoSiteContentsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorInfoSiteContent"] = decodeMessageRepeated(ctx, VisitorInfoSiteContent.codec, v["visitorInfoSiteContent"], "visitorInfoSiteContent");
      return out as any as Entity;
    }
  }();
}

export namespace ListWayfindingMapsRequest {
  export const refName = "mos.org.getty.visitor_info_access.ListWayfindingMapsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListWayfindingMapsRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.visitor_info_access.ListWayfindingMapsRequest.BySite") {
            obj["bySite"] = ListWayfindingMapsRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.visitor_info_access.ListWayfindingMapsRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListWayfindingMapsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListWayfindingMapsRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace BySite {
    export const refName = "mos.org.getty.visitor_info_access.ListWayfindingMapsRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListWayfindingMapsRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListWayfindingMapsResponse {
  export const refName = "mos.org.getty.visitor_info_access.ListWayfindingMapsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly wayfindingMaps: ReadonlyArray<WayfindingMap.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    wayfindingMaps: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["wayfindingMaps"] = [];
      for (const item of v.wayfindingMaps) {
        obj["wayfindingMaps"].push(WayfindingMap.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info_access.ListWayfindingMapsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["wayfindingMaps"] = decodeMessageRepeated(ctx, WayfindingMap.codec, v["wayfindingMaps"], "wayfindingMaps");
      return out as any as Entity;
    }
  }();
}

